import IntegrationRefundid from '../../images/refund-providers/refundid.svg';
import IntegrationReveni from '../../images/refund-providers/reveni.svg';
import IntegrationRise from '../../images/refund-providers/rise.svg';

export enum RESOLUTION_TYPE {
    Credits = 0,
    GiftCard = 7,
    Refund = 1,
    BankRefund = 4,
    CancelOrderType = 5,
    InstantRefundType = 9,
    NoOffersType = 10,
    PlatformStoreCreditType = 12,
    DirectVariantExchange = 2,
    ManualExchangeType = 6,
    ProductExchangeType = 8,
};

export enum RETURN_ALTERNATIVE {
    SHIP_LATER = 0,
    KEEP = 1,
    DONATE = 2,
    ORIG_PAY_REFUND = 3,
    REFUND_TO_CREDIT = 4,
    INSTANT_VARIANT_EXCHANGE = 5,
    BANK_REFUND = 6,
    CANCEL_ORDER = 7,
    MANUAL_EXCHANGE = 8,
    REFUND_TO_GIFT_CARD = 9,
    PRODUCT_EXCHANGE = 10,
    INSTANT_REFUND = 11,
    NO_OFFERS = 12,
};

export enum RESOLUTION_ID {
    SHIP_LATER = 1,
    KEEP = 2,
    DONATE = 3,
    ORIG_PAY_REFUND = 4,
    REFUND_TO_CREDIT = 5,
    INSTANT_VARIANT_EXCHANGE = 6,
    REFUND_TO_BANK = 7,
    CANCEL_ORDER = 8,
    MANUAL_EXCHANGE = 9,
    REFUND_TO_GIFT_CARD = 10,
    PRODUCT_EXCHANGE = 11,
    INSTANT_REFUND = 12,
    NO_OFFERS = 13,
    REFUND_TO_PLATFORM_STORE_CREDIT = 15,
};

export const RESOLUTION_IDS_OF_TYPE_EXCHANGE = [
    RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE,
    RESOLUTION_ID.MANUAL_EXCHANGE,
    RESOLUTION_ID.PRODUCT_EXCHANGE,
];

export const RESOLUTION_IDS_OF_TYPE_ORDER_MODIFICATION = [
    RESOLUTION_ID.CANCEL_ORDER
];

/*
 * ...there should have been RESOLUTION_IDS_OF_TYPE_RETURN list here
 * but apparently we calculate it dynamically by following logic:
 *   - if not resolution_id is not in RESOLUTION_IDS_OF_TYPE_EXCHANGE
 *     AND NOT in RESOLUTION_IDS_OF_TYPE_ORDER_MODIFICATION
 *     THEN it is of type RESOLUTION_IDS_OF_TYPE_RETURN
 * Hope that makes sense!
 */

export enum VOUCHER_TYPE {
    GIFT_CARD = 'gift_card',
    DISCOUNT_CODE = 'discount_code',
};

type IVoucherType = {
    [key in VOUCHER_TYPE]: { value: VOUCHER_TYPE, label: string }
};

export const VOUCHER_TYPE_MAP: IVoucherType = {
    [VOUCHER_TYPE.DISCOUNT_CODE]: {
        value: VOUCHER_TYPE.DISCOUNT_CODE, label: 'Credits'
    },
    [VOUCHER_TYPE.GIFT_CARD]: {
        value: VOUCHER_TYPE.GIFT_CARD, label: 'Gift Card'
    },
};

export function voucherTypeList() {
    return Object.keys(VOUCHER_TYPE_MAP).map(k => {
        return VOUCHER_TYPE_MAP[(k as unknown) as VOUCHER_TYPE];
    });
}

export enum REFUND_BY {
    NEW_GIFT_CARD = 'NEW_GIFT_CARD',
    ORIGINAL_PAYMENT_METHOD = 'ORIGINAL_PAYMENT_METHOD',
    STORE_CREDIT = 'STORE_CREDIT',
};

export enum CREDIT_AMOUNT_TYPE {
    LESS = 0,
    MORE = 1,
    FIXED = 2,
    PAID_AMOUNT = 3,
};

export enum IMAGE_OPTION {
    NONE = 0,
    OPTIONAL = 1,
    MANDATORY = 2,
}

type IImageOption = {
    [key in IMAGE_OPTION]: { value: IMAGE_OPTION, label: string }
};

export const IMAGE_OPTION_MAP: IImageOption = {
    [IMAGE_OPTION.NONE]: {
        value: IMAGE_OPTION.NONE, label: 'None'
    },
    [IMAGE_OPTION.OPTIONAL]: {
        value: IMAGE_OPTION.OPTIONAL, label: 'Optional'
    },
    [IMAGE_OPTION.MANDATORY]: {
        value: IMAGE_OPTION.MANDATORY, label: 'Mandatory'
    },
};

export function imageOptionList() {
    return Object.keys(IMAGE_OPTION_MAP).map(k => {
        return IMAGE_OPTION_MAP[(k as unknown) as IMAGE_OPTION];
    });
}

export enum INSTANT_REFUND_PROVIDER {
    Refundid = 'refundid',
    Reveni = 'reveni',
    Rise = 'rise',
}

export const INSTANT_REFUND_PROVIDER_IMAGE_MAP = {
    [INSTANT_REFUND_PROVIDER.Refundid] : IntegrationRefundid,
    [INSTANT_REFUND_PROVIDER.Reveni] : IntegrationReveni,
    [INSTANT_REFUND_PROVIDER.Rise] : IntegrationRise,
}

export enum EXCHNAGE_RESOLUTION_TYPE {
    INSTANT_VARIANT_EXCHANGE = RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE,
    PRODUCT_EXCHANGE = RESOLUTION_ID.PRODUCT_EXCHANGE,
    MANUAL_EXCHANGE = RESOLUTION_ID.MANUAL_EXCHANGE,
}

export const RELEASE_ABLE_RESOLUTIONS_IDS: RESOLUTION_ID[] = [
    RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE,
    RESOLUTION_ID.PRODUCT_EXCHANGE,
];

export const REFUND_RESOLUTIONS_TYPES: RESOLUTION_TYPE[] = [
    RESOLUTION_TYPE.Credits,
    RESOLUTION_TYPE.PlatformStoreCreditType,
    RESOLUTION_TYPE.GiftCard,
    RESOLUTION_TYPE.Refund,
    RESOLUTION_TYPE.BankRefund,
    RESOLUTION_TYPE.CancelOrderType,
    RESOLUTION_TYPE.InstantRefundType,
    RESOLUTION_TYPE.NoOffersType,
];

type IExchangeResolutionOption = {
    [key in EXCHNAGE_RESOLUTION_TYPE]: { value: EXCHNAGE_RESOLUTION_TYPE, label: string }
}

export const EXCHANGE_RESOLUTION_MAP: IExchangeResolutionOption = {
    [EXCHNAGE_RESOLUTION_TYPE.INSTANT_VARIANT_EXCHANGE]: {
        value: EXCHNAGE_RESOLUTION_TYPE.INSTANT_VARIANT_EXCHANGE, label: 'Variant Exchange'
    },
    [EXCHNAGE_RESOLUTION_TYPE.PRODUCT_EXCHANGE]: {
        value: EXCHNAGE_RESOLUTION_TYPE.PRODUCT_EXCHANGE, label: 'Product Exchange'
    },
    [EXCHNAGE_RESOLUTION_TYPE.MANUAL_EXCHANGE]: {
        value: EXCHNAGE_RESOLUTION_TYPE.MANUAL_EXCHANGE, label: 'Manual Exchange'
    },
}

export enum ALLOW_OUT_OF_STOCK_EXCHANGE_OPTION {
    ALLOW = 'ALL',
    BLOCK = 'BLOCK',
    SOME = 'SOME'
}

export function exchangeresolutionTypeList() {
    return Object.keys(EXCHANGE_RESOLUTION_MAP).map(k => {
        return EXCHANGE_RESOLUTION_MAP[(k as unknown) as EXCHNAGE_RESOLUTION_TYPE];
    });
}

export enum SHIPPING_LINE_TYPE {
    LEAVE_BLANK = 'LEAVE_BLANK',
    SELECT_FIRST_FREE_SHIPPING = 'SELECT_FIRST_FREE_SHIPPING',
    CREATE_CUSTOM_FREE_SHIPPING = 'CREATE_CUSTOM_FREE_SHIPPING',
    SELECT_SPECIFIC_FREE_SHIPPING = 'SELECT_SPECIFIC_FREE_SHIPPING',
};

export const SHIPPING_LINE_TYPES_WITH_TITLE_MAP = [
    SHIPPING_LINE_TYPE.CREATE_CUSTOM_FREE_SHIPPING,
    SHIPPING_LINE_TYPE.SELECT_SPECIFIC_FREE_SHIPPING,
];

export const RATELESS_SHIPPING_LINE_TYPES = [
    SHIPPING_LINE_TYPE.LEAVE_BLANK,
    SHIPPING_LINE_TYPE.CREATE_CUSTOM_FREE_SHIPPING,
];

export enum FALLBACK_SHIPPING_TYPE {
    LEAVE_BLANK = 'LEAVE_BLANK',
    CREATE_CUSTOM_FREE_SHIPPING = 'CREATE_CUSTOM_FREE_SHIPPING',
};